import React from 'react';

/**
 * Product-page texture close-up — the macro photo of the Round with a
 * sensory caption. Intentionally describes how it FEELS, not how it's made:
 * no structural/process detail (that crosses the public-site IP line).
 */
export function TextureCloseup() {
  return (
    <section className="section fade-in">
      <div className="section-label">Up close</div>
      <h2>Texture you can see.</h2>
      <div className="composite-texture">
        <img
          src={`${process.env.PUBLIC_URL}/images/product/truenooch-texture.webp`}
          alt="Extreme close-up of TrueNooch™ on the back of a butter knife — pale golden-cream, a smooth creamy body with a fine whole-food grain, a single flake of sea salt resting on the surface."
          loading="lazy"
        />
        <div className="composite-texture-caption">
          Sliceable and smooth, never greasy — a clean, creamy body with a fine whole-food grain you can see up close.
        </div>
      </div>
    </section>
  );
}
